import styled, { css } from 'styled-components';
import {
  color,
  space,
  opacity,
  border,
  display,
  typography,
  position,
  flexbox,
} from 'styled-system';

const getMaxHeight = ({ lineHeight, numberOfLines }) => {
  if (typeof lineHeight === 'number') {
    return `calc(${lineHeight}em*${numberOfLines})`;
  }

  if (typeof lineHeight === 'string') {
    lineHeight = parseInt(lineHeight);
  }

  return `calc(${lineHeight}px*${numberOfLines})`;
};

const ellipsisStyle = css`
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: ${({ numberOfLines }) => numberOfLines};
  max-height: ${getMaxHeight};
`;

const Text = styled.div`
  ${position};
  ${space};
  ${opacity};
  ${typography};
  cursor: ${({ cursor }) => (cursor ? cursor : 'inherit')};
  ${border};
  ${display};
  ${color};
  ${flexbox};
  white-space: ${({ whiteSpace }) => (whiteSpace ? whiteSpace : 'inherit')};
  ${props => props.numberOfLines && ellipsisStyle}
`;

Text.defaultProps = {
  fontWeight: 500,
  lineHeight: '24px',
  color: 'darkBlack',
};

export default Text;
